/**
 * Workspace library exports
 */

// Context
export { WorkspaceProvider, useWorkspaceContext } from './context';

// Utils (removed setStoredActiveWorkspaceId - should be internal only)

// Hooks
export { 
  useWorkspace,
  useActiveWorkspace, 
  useAvailableWorkspaces, 
  useIsActiveWorkspaceAdmin, 
  useCanEditActiveWorkspace, 
  useActiveWorkspaceRole 
} from './hooks';

// Constants
export { WorkspaceRole, SYSTEM_WORKSPACE_ID } from './constants';

// Actions
export { createWorkspace } from './actions';
export type { CreateWorkspaceParams, CreateWorkspaceResult } from './actions';

// Types from API
export type { Workspace } from '../api/types';
export type { WorkspaceContextValue } from './context'; 